import PropTypes from 'prop-types';
import { HelperText } from './HelperText';

// One settings-form field cell: mono uppercase label + control + optional
// error helper. Styled by the `cfg-form__*` rules in
// '@/shared/OrgModales/ModalForm.css', which the consuming modals import.
export function Field({ label, error, full, children }) {
  return (
    <div className={`cfg-form__field${full ? ' cfg-form__field--full' : ''}`}>
      <span className="cfg-form__label">{label}</span>
      {children}
      {error && <HelperText kind="err">{error}</HelperText>}
    </div>
  );
}

Field.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  full: PropTypes.bool,
  children: PropTypes.node,
};

export default Field;
